export class Event {
  constructor(public name:string, public data?:any){}
}

class EventService {

  private subscribers: Map<string,((event: Event) => void)[]> = new Map<string, ((event: Event) => void)[]>();

  publish (event:Event) {
    let callbacks = this.subscribers.get(event.name);
    if (callbacks) {
      for (let cb of callbacks) {
        cb(event);
      }
    }
  }

  subscribe(event:string, callback: (event: Event) => void) {
    let callbacks = this.subscribers.get(event);
    if (!callbacks) {
      callbacks = [];
    }
    callbacks.push(callback);

    this.subscribers.set(event, callbacks);
  }

  unSubscribe(event: string, callback: (event: Event) => void) {
    let callbacks = this.subscribers.get(event);
    if (callbacks) {
      let i = callbacks.findIndex(it => it === callback);
      if (i >= 0) {
        callbacks.splice(i,1);
      }
    }
  }

}

// Export a singleton instance in the global namespace
export const eventService = new EventService();